import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {CutOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/cut-operator/geometry-cut-operator-node"
import {GeometryCutOperatorNode, cutOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute-set/cut-operator/geometry-cut-operator-node"

const definition: TemplateNodeDefinition<CutOperatorParameters> = {
    nodeClass: "MeshGeometryCutOperator",
    validation: {
        parameters: cutOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryCutOperator extends GeometryCutOperatorNode implements MeshGeometryAttributeSetLikeNode {
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
